module.exports = __webpack_public_path__ + "img/FR13528.5eda7365.png";